/**
 * Visual/semantic tag for a tail segment.
 *
 * Keep this purely as a "skin" concept: it must not change collision rules.
 * Gameplay meaning lives in Charge / effects, not here.
 *
 * Values are lowercase strings to keep them stable in serialization.
 */
export enum SegmentSkin {
  Normal = "normal",
  Spent = "spent",

  // Food / segment visuals (unspent)
  Red = "red",
  Gold = "gold",
  Blue = "blue",
  Purple = "purple",
  Star = "star",
  Icy = "icy",

  // Optional generic tag for "any laser-y segment"
  Laser = "laser",
}
